import uniq from 'lodash/uniq';
import { hasRequiredFields } from '.';

const XMLparser = require('fast-xml-parser');

const filterEmptyString = (arr) => {
  const filteredArr = arr[arr.length - 1] === '' ? arr.slice(0, arr.length - 1) : arr;
  return filteredArr;
};

export const validateXMLUpload = (xmlUpload) => {
  const options = {
    attributeNamePrefix: '@_',
    attrNodeName: 'attr',
    textNodeName: '#text'
  };
  if (XMLparser.validate(xmlUpload)) {
    const jsonObj = XMLparser.parse(xmlUpload, options);
    const jobs = jsonObj.source.job;
    const formattedJobs = filterEmptyString(jobs);
    const fieldCheck = hasRequiredFields(formattedJobs);
    return !fieldCheck.missing && !fieldCheck.missingFields ?
      fieldCheck.jobs :
      { missing: uniq(fieldCheck.missing), missingFields: fieldCheck.missingFields };
  }
};
